module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNiAwIDEgNWw1IDUiIHN0cm9rZT0iIzVDNUQ1RiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/shop-cart-left.svg
// module id = J/IF
// module chunks = 42